"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var createMemoizingGetter;

exports.default = createMemoizingGetter = function (target, key, defaultValue, getOnce) {
  var reentrancyLock;
  reentrancyLock = false;
  return function () {
    var finalValue;
    if (reentrancyLock || this === target.prototype || this.hasOwnProperty(key)) {
      return defaultValue;
    }
    finalValue = getOnce.call(this);
    reentrancyLock = true;
    Object.defineProperty(this, key, {
      value: finalValue,
      configurable: true,
      writable: true
    });
    reentrancyLock = false;
    return finalValue;
  };
};